import * as api from "../../shared/api"
import apiPath from "../../shared/apiPath"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "SEI_InventTable"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const descriptor = {}
const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },
    {
      key: "TEC_CustAccount",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },
    {
      key: "TEC_NetArea",
      label: "净面积",
      sortable: true,
      type: "number"
    },
    {
      key: "TEC_SpecType",
      label: "规格型号",
      sortable: true
    },
    {
      key: "TEC_Weight",
      label: "单位重量",
      sortable: true,
      type: "number"
    },
    {
      key: "DW_InventUnitId",
      label: "单位",
      sortable: true
    },
    {
      key: "DW_ItemGroupId",
      label: "物料组",
      sortable: true
    },
    {
      key: "DW_EcoResCategoryCode1",
      label: "一级大类编号",
      sortable: true
    },
    {
      key: "DW_EcoResCategoryName1",
      label: "一级大类名称",
      sortable: true
    },
    {
      key: "DW_EcoResCategoryCode2",
      label: "二级大类编号",
      sortable: true
    },
    {
      key: "DW_EcoResCategoryName2",
      label: "二级大类名称",
      sortable: true
    },
    {
      key: "DW_EcoResCategoryCode3",
      label: "三级大类编号",
      sortable: true
    },
    {
      key: "DW_EcoResCategoryName3",
      label: "三级大类名称",
      sortable: true
    },
    {
      key: "modifiedDateTime",
      label: "修改日期和时间",
      type: "datetime"
    }
  ],
  detail_fields: [
    {
      key: "dataAreaId",
      label: "公司",
      sortable: true
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "ItemId",
      label: "物料编号",
      route_link_to: "Home"
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "TEC_CustAccount",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "DW_CustName",
      label: "客户名称",
      sortable: true
    },
    // {
    //   key: "RetailVariantId",
    //   label: "变形编号",
    //   sortable: true,
    //   thStyle: {
    //     display: "none"
    //   },
    //   tdClass: "no-shown-RetailVariantId"
    // },

    {
      key: "Height",
      label: "长度",
      sortable: true,
      type: "number"
    },
    {
      key: "Width",
      label: "宽度",
      sortable: true,
      type: "number"
    },
    {
      key: "Depth",
      label: "高度",
      sortable: true,
      type: "number"
    },
    {
      key: "UnitVolume",
      label: "体积",
      sortable: true,
      type: "number"
    },
    {
      key: "NetWeight",
      label: "净重",
      sortable: true,
      type: "number"
    },
    {
      key: "TEC_NetArea",
      label: "净面积",
      sortable: true,
      type: "number"
    },
    {
      key: "TEC_Weight",
      label: "单位重量",
      sortable: true,
      type: "number"
    },
    {
      key: "CostGroupId",
      label: "成本组",
      sortable: true
    },
    {
      key: "ReqGroupId",
      label: "覆盖范围组",
      sortable: true
    },
    {
      key: "TaxGroup",
      label: "税组",
      sortable: true
    },
    {
      key: "MinimumPalletQuantity",
      label: "最小输出托盘数量",
      sortable: true,
      type: "number"
    },
    {
      key: "BatchNumGroupId",
      label: "批处理号组",
      sortable: true
    },
    {
      key: "OrigCountryRegionId",
      label: "国家/地区",
      sortable: true
    },
    {
      key: "standardPalletQuantity",
      label: "托盘数量",
      sortable: true,
      type: "number"
    },
    {
      key: "BOMCalcGroupId",
      label: "计算组",
      sortable: true
    },
    {
      key: "PmfProductType",
      label: "生产类型",
      sortable: true
    },
    {
      key: "VendTable",
      label: "供应商帐户",
      sortable: true
    },
    {
      key: "TEC_SpecType",
      label: "规格型号",
      sortable: true
    },
    {
      key: "SEI_StructureName",
      label: "结构名称",
      sortable: true
    },
    {
      key: "SEI_DimensionFG",
      label: "FG维度",
      sortable: true
    },
    {
      key: "DW_InventUnitId",
      label: "单位",
      sortable: true
    },
    {
      key: "DW_ItemGroupId",
      label: "物料组",
      sortable: true
    },
    {
      key: "SEI_Workshop",
      label: "描述",
      sortable: true
    },
    {
      key: "DW_EcoResCategoryCode1",
      label: "一级大类编号",
      sortable: true
    },
    {
      key: "DW_EcoResCategoryName1",
      label: "一级大类名称",
      sortable: true
    },
    {
      key: "DW_EcoResCategoryCode2",
      label: "二级大类编号",
      sortable: true
    },
    {
      key: "DW_EcoResCategoryName2",
      label: "二级大类名称",
      sortable: true
    },
    {
      key: "DW_EcoResCategoryCode3",
      label: "三级大类编号",
      sortable: true
    },
    {
      key: "DW_EcoResCategoryName3",
      label: "三级大类名称",
      sortable: true
    },
    {
      key: "SEI_ProjectId",
      label: "项目编号",
      sortable: true
    },
    {
      key: "SEI_CustItemId",
      label: "客户料号",
      sortable: true
    },
    {
      key: "SEI_ColorCountry",
      label: "颜色",
      sortable: true
    },
    {
      key: "SEI_Location_Id",
      label: "国家代码",
      sortable: true
    },
    {
      key: "SEI_CopackType",
      label: "组装标识",
      sortable: true
    },
    {
      key: "SEI_HSCode",
      label: "海关编码",
      sortable: true
    },
    {
      key: "DW_inventBatchIdPurch",
      label: "采购仓库",
      sortable: true
    },
    {
      key: "DW_inventBatchIdSales",
      label: "销售仓库",
      sortable: true
    },
    {
      key: "DW_LeadTime",
      label: "采购提前期",
      sortable: true
    },
    {
      key: "DW_Capacity",
      label: "产能",
      sortable: true
    },
    {
      key: "Stopped",
      label: "停用",
      sortable: true
    },
    {
      key: "DW_LowestQty",
      label: "最小起订量",
      sortable: true
    },
    {
      key: "createdBy",
      label: "创建人",
      sortable: true
    },
    {
      key: "createdDateTime",
      label: "创建日期和时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "SEI_modifiedDateTime",
      label: "修改日期和时间",
      type: "datetime"
    }
  ],
  price_fields: [
    {
      key: "id",
      label: "编号",
      sortable: true
    },
    {
      key: "Agreement",
      label: "价格协议"
    },
    {
      key: "dataAreaId",
      label: "公司"
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "ItemRelation",
      label: "物料关系"
    },
    {
      key: "AccountRelation",
      label: "帐户选择"
    },
    {
      key: "Amount",
      label: "价格"
    },
    {
      key: "SEI_PriceCost",
      label: "成本"
    },
    {
      key: "QuantityAmountFrom",
      label: "数量(从)"
    },
    {
      key: "QuantityAmountTo",
      label: "数量(到)"
    },
    {
      key: "FromDate",
      label: "开始日期",
      type: "date"
    },
    {
      key: "ToDate",
      label: "结束日期",
      type: "date"
    },
    {
      key: "relation",
      label: "关系"
    },
    {
      key: "ItemCode",
      label: "物料代码"
    },
    {
      key: "AccountCode",
      label: "帐户编码"
    }
  ]
}

const dataForm = {}

///前端验证
const rules = {}

const methods = {
  ///get
  async getDataNoSql(_params) {
    let _fields = _.map(fields.default, "key")
    _fields.push("is_deleted_ax")
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getData(_params) {
    const biz_data = new biz_data_helper.base_entity_helper(
      "get_sei_invent",
      {},
      {}
    )
    // console.log(_.join(_.map(fields.detail_fields, "key"), ",a."));
    // return;
    let result = await biz_data
      .execAction({
        params: _params,
        fields: _.map(fields.detail_fields, "key")
      })
      .run()
    // let result = await biz_data
    //   .selectAction({
    //     params: _params,
    //     fields: _.map(fields.default, "key")
    //   })
    //   .run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //get item
  async getItemData(_params) {
    const item_biz_data = new biz_data_helper.base_entity_helper(
      "get_invent",
      {},
      {}
    )
    let _fields = _.map(fields.detail_fields, "key")
    let result = await item_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },

  async getSOInventData(_params) {
    const so_invent_biz_data = new biz_data_helper.base_entity_helper(
      "get_so_invent",
      {},
      {}
    )
    let result = await so_invent_biz_data
      .execAction({
        params: _params,
        fields: _.map(fields.detail_fields, "key")
      })
      .run()
    // let result = await biz_data
    //   .selectAction({
    //     params: _params,
    //     fields: _.map(fields.default, "key")
    //   })
    //   .run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },

  async getTop100InventKvData(_params) {
    const so_invent_biz_data = new biz_data_helper.base_entity_helper(
      "get_kv_invent",
      {},
      {}
    )
    let result = await so_invent_biz_data.execAction({
      params: _params,
      fields: _.map(fields.detail_fields, "key")
    }).run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async pickAndInvoke(params) {
    let result = await api.query_async({
      url: apiPath.axInterface.pickand_invoke,
      parameters: params,
      method: "get"
    })

    if (
      result &&
      result[0] &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.length > 0 &&
      result[0].result.data[0].status == 0
    ) {
      return result[0].result.data[0].data
    } else {
      return null
    }
  }
}

export { biz_data, dataForm, fields, methods, rules }

